import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { OrisModule } from '@src/clients/oris/oris.module';
import { environment } from '@src/environments/environment';
import { EnvironmentNames } from '@src/environments/environments.name';

if (environment.envName === EnvironmentNames.prod) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(OrisModule)
  .catch(err => console.log(err));
